var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotCheckedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_42717",
    "data-name": "Path 42717",
    d: "M24,0A24,24,0,1,0,48,24,24.028,24.028,0,0,0,24,0ZM37.414,17.684,22.075,32.9a2.36,2.36,0,0,1-3.308.06l-8.12-7.4a2.44,2.44,0,0,1-.18-3.368,2.38,2.38,0,0,1,3.368-.12l6.436,5.895L33.985,14.256a2.424,2.424,0,0,1,3.429,3.429Z",
    transform: "translate(0.5 0.5)",
    fill: "#f0f0f0",
    stroke: "#f0f0f0",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotCheckedIcon);
export default __webpack_public_path__ + "static/media/notCheckedIcon.b314e4ded66515cbd710cd7c8504a46d.svg";
export { ForwardRef as ReactComponent };